import {
  BaseLayoutSchema,
  CommonInputWidgetConfigSchema,
  ComputeExpressionSchema,
} from '@framework/engine';
import { yup } from '@framework/validation';
import { IBurdenWidget, WidgetTypeBurden } from './IBurdenWidget';

export const BurdenWidgetConfigSchema: yup.ObjectSchema<IBurdenWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().required().exact(WidgetTypeBurden).label('Tipo'),
    macroBurdenTypeId: yup.string().required().label('Tipo di onere'),
    macroBurdenType: yup.object(),
    expression: ComputeExpressionSchema.label('Importo Calcolato'),
    layout: BaseLayoutSchema.shape({
      hide: yup.boolean().required().default(false).label('Nascondi elemento'),
      removeBorder: yup
        .boolean()
        .required()
        .default(false)
        .label('Rimuovi bordo'),
    }),
  })
    .required()
    .noUnknown();
